<template>
  <div class="web-message-packets-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Qual pacote de mensagem você gostaria?
          </p>
        </div>
      </div>
      <div class="columns mt-6 is-multiline">
        <div
            class="column is-half-desktop is-full-mobile is-full-tablet"
            v-for="(messagePacket, index) in formData.plan.data.messagePackets"
            :key="index"
        >
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <div
                class="box is-size-3 mx-4 mx-2-mobile p-6 py-4-mobile px-3-mobile has-text-centered is-fullwidth"
                :class="{
                  'is-white is-outlined': formData.plan.data.seasonality !== 12 && messagePacket.mode === 2
                }"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 is-size-3-mobile has-text-weight-bold">
                    <span v-if="messagePacket.mode === 2">
                      ILIMITADO
                    </span>
                    <span v-else>
                      PADRÃO
                    </span>
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width">
                    <div class="columns">
                      <div class="column" v-if="messagePacket.mode === 2">
                        <span class="has-text-grey-dark is-size-6 is-size-7-mobile is-desktop is-pulled-left">R$</span>
                        <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                           {{ messagePacket.originalPrice ?  formatPrice(messagePacket.originalPrice) : formatPrice(messagePacket.price)}}
                        </span>
                        <span class="has-text-grey-dark is-size-6 is-size-7-mobile">
                          /MÊS
                        </span>
                      </div>
                      <div v-else>
                        <div class="column pb-0 is-flex is-justify-content-center">
                          <span class="has-text-grey-dark is-size-6 is-size-7-mobile is-desktop is-pulled-left">R$</span>
                          <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                            {{ formatPrice(messagePacket.price) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span v-if="messagePacket.mode === 2" class="tag is-primary is-small is-size-7-mobile">
                    POR CONEXÃO
                  </span>
                  <span v-else class="tag is-primary is-small is-size-7-mobile">
                    POR MENSAGEM ENVIADA
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <button
                      v-if="formData.plan.data.seasonality !== 12 && messagePacket.mode === 2"
                      class="button is-primary is-inverted is-border is-size-5 is-size-6-mobile is-medium has-text-weight-medium is-four-fifths disabled is-cursor-default"
                  >
                    <div class="is-fullwidth is-flex is-justify-content-center has-text-centered">
                      Apenas para planos anuais
                    </div>
                  </button>
                  <button
                      v-else
                      class="button is-primary is-size-5 is-size-6-mobile is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="chooseMessagePacket(messagePacket)"
                  >
                    <div class="is-fullwidth">
                      Quero este
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6">
      <div class="columns">
        <div class="column is-full is-flex is-justify-content-start is-align-content-start">
          <button
              class="button is-primary is-size-4 is-size-6-mobile is-large has-text-weight-medium mobile-back-btn"
              @click.prevent="$emit('previousTab')"
          >
            <div class="is-flex is-align-items-center">
              <span class="icon-text pr-2">
                <
              </span>
              <span v-if="isMobile" class="mobile-btn-text">Voltar</span>
              <span v-else class="desktop-btn-text">Escolher outro plano</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'messagePackets',

  data() {
    return {
      originalPrice: null,
      isMobile: false
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {

    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },

    chooseMessagePacket(messagePacket) {
      if (!this.formData.messagePacket.data.originalPrice) {
        this.originalPrice = messagePacket.price
      }
      this.formData.messagePacket.hasSum = messagePacket.mode === 2
      this.formData.messagePacket.showStep = true
      this.formData.messagePacket.data = messagePacket
      this.formData.messagePacket.data.quantity = 1
      this.formData.messagePacket.data.originalPrice = this.originalPrice
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
      
      // Abrir sidebar automaticamente no mobile
      if (window.innerWidth < 1024) { // 1024px é o breakpoint desktop do Bulma
        appStore.isMobileSidebarVisible = true;
      }

      // Rolar para a seção de resumo do plano
      this.scrollToPlanSummary();
    },
    
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    },

    scrollToPlanSummary() {
      // Timeout para garantir que a DOM será atualizada primeiro
      setTimeout(() => {
        // Em dispositivos móveis, o resumo está na parte inferior da página
        if (window.innerWidth < 1024) {
          // Elemento de resumo no modo mobile
          const reviewElement = document.querySelector('.mobile-summary-container');
          if (reviewElement) {
            reviewElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            // Alternativa: rolar para o final da página
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
        } else {
          // Em desktop, o resumo está na sidebar à direita
          const sidebarElement = document.querySelector('.review-sidebar-component');
          if (sidebarElement) {
            const topPosition = sidebarElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: topPosition - 80, // Ajuste para considerar a navbar
              behavior: 'smooth'
            });
          }
        }
      }, 100);
    }
  },

  mounted() {
    const appStore = useAppStore()
    appStore.showReviewNextButton = false
    
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }

}

</script>

<style lang="scss" scoped>
.web-message-packets-component {
  .box {
    transition: all 0.3s ease;
    
    &:hover:not(.is-outlined) {
      transform: translateY(-5px);
      box-shadow: 0 8px 15px rgba(0,0,0,0.1);
    }
  }
  
  .mobile-back-btn {
    transition: all 0.2s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }
}

@media screen and (max-width: 768px) {
  .web-message-packets-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-6-mobile {
      font-size: 0.9rem !important;
    }
    
    .is-size-7-mobile {
      font-size: 0.75rem !important;
    }
    
    .mx-2-mobile {
      margin-left: 0.5rem !important;
      margin-right: 0.5rem !important;
    }
    
    .py-4-mobile {
      padding-top: 1rem !important;
      padding-bottom: 1rem !important;
    }
    
    .px-3-mobile {
      padding-left: 0.75rem !important;
      padding-right: 0.75rem !important;
    }
    
    .tag.is-primary {
      white-space: normal;
      height: auto;
      padding: 0.25rem 0.5rem;
      line-height: 1.2;
    }
    
    .mobile-back-btn {
      padding: 0.5rem 1rem !important;
      height: auto !important;
      font-size: 0.9rem !important;
      width: auto !important;
      
      .icon-text {
        font-size: 1rem;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .web-message-packets-component {
    .mobile-back-btn {
      padding: 0.5rem !important;
      width: auto !important;
    }
  }
}

@media screen and (min-width: 769px) {
  .web-message-packets-component {
    .mobile-back-btn {
      width: auto;
      min-width: 200px;
    }
    
    .desktop-btn-text {
      font-size: 1rem;
    }
  }
}
</style>